// extracted by mini-css-extract-plugin
export default {"footer":"footer-main-sendoso__footer___GXoao","copyright":"footer-main-sendoso__copyright___aibUY"};